<template>
  <div class="odm-page">
    <WebHeader />
    <OdmCarousel />
    <OdmIntroduce id="odm_intro"/>
    <ServiceDeliver id="odm_deliver"/>
    <OurLab id="our_lab"/>
    <WebFooter />
  </div>
</template>

<script>
import WebHeader from '../../components/common/WebHeader.vue'
import OdmCarousel from './odmCarousel.vue'
import OdmIntroduce from './odmIntroduce.vue'
import ServiceDeliver from './serviceDeliver.vue'
import OurLab from '../aboutUs/ourLab.vue'
import WebFooter from '../../components/common/WebFooter.vue'

export default {
  name: 'App',
  components: {
    WebHeader,
    OdmCarousel,
    OdmIntroduce,
    ServiceDeliver,
    OurLab,
    WebFooter
  }
}

</script>

<style scoped>
</style> 